var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvito(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 11.35c0-4.997 0-7.495 1.552-9.048C3.855.75 6.353.75 11.35.75h5.3c4.997 0 7.495 0 9.048 1.552 1.552 1.553 1.552 4.051 1.552 9.048v5.3c0 4.997 0 7.495-1.552 9.048-1.553 1.552-4.051 1.552-9.048 1.552h-5.3c-4.997 0-7.495 0-9.048-1.552C.75 24.145.75 21.647.75 16.65v-5.3z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.731-.575a6.294 6.294 0 1 0 0 12.588 6.294 6.294 0 0 0 0-12.588z",
    fill: "#A3EA5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14-2.563C6.682-2.563.75 3.37.75 10.688c0 7.318 5.932 13.25 13.25 13.25s13.25-5.932 13.25-13.25c0-7.317-5.932-13.25-13.25-13.25z",
    fill: "#A169F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.044 22.613a5.631 5.631 0 1 0 0 11.262 5.631 5.631 0 0 0 0-11.262z",
    fill: "#FF6163"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6 19.3a6.625 6.625 0 1 0 0 13.25 6.625 6.625 0 0 0 0-13.25z",
    fill: "#0AF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m12.134 18.388-.888-2.686H7.381l-.902 2.686h-1.9L8.306 7.885h2.11l3.734 10.503h-2.016zM9.26 9.886l-1.44 4.331h2.99l-1.426-4.33h-.124zm9.92 1.806h-1.564v1.986h1.42c.895 0 1.331-.356 1.331-1.004 0-.597-.386-.982-1.186-.982zm-.036 3.173h-1.528v2.256h1.689c.895 0 1.383-.4 1.383-1.128 0-.764-.54-1.128-1.544-1.128zm-3.311 3.523v-7.963h3.763c1.601 0 2.54.779 2.54 2.016 0 .815-.59 1.543-1.383 1.681v.132c1.048.109 1.74.866 1.74 1.834 0 1.39-1.078 2.3-2.846 2.3h-3.814z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 11.35c0-4.997 0-7.495 1.552-9.048C3.855.75 6.353.75 11.35.75h5.3c4.997 0 7.495 0 9.048 1.552 1.552 1.553 1.552 4.051 1.552 9.048v5.3c0 4.997 0 7.495-1.552 9.048-1.553 1.552-4.051 1.552-9.048 1.552h-5.3c-4.997 0-7.495 0-9.048-1.552C.75 24.145.75 21.647.75 16.65v-5.3z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: -17.336,
    y: -17.336,
    width: 63.335,
    height: 65.985,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.387,
    result: "effect1_foregroundBlur_5146_85558"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvito);
export default __webpack_public_path__ + "static/media/avito.c0d1cf07224e9bcd900607e421964541.svg";
export { ForwardRef as ReactComponent };